/* kk-countdown.js — <kk-countdown data-end="YYYY-MM-DD HH:MM" data-tz="Europe/Berlin" data-expired="hide|zero">
   Renders D / H / M / S boxes ([data-cd-d] … [data-cd-s]) until the deadline, interpreted in the given
   IANA time zone (DST-safe via Intl). When expired: data-expired="hide" hides the closest
   [data-cd-wrap] (or itself) and adds .is-expired; "zero" keeps 00:00:00.
   v4.37 (2026-10-07): optional data-start="YYYY-MM-DD HH:MM" - hidden until the start moment (base.css hides
   kk-countdown[data-start] until .is-live is set, so nothing flashes before JS). Inputs inside marked
   [data-cd-input] are enabled only while live. Elements with data-hide-start / data-hide-end are hidden
   INSIDE that window (e.g. the 2er Set tile during a 1+1 promo); a hidden active set tile hands over to the first visible one.
   Used by the announcement-bar countdown block and the main-product promo_deal block. */
(function () {
  function tzOffsetMs(date, tz) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    var p = {};
    f.formatToParts(date).forEach(function (x) { p[x.type] = x.value; });
    var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
    return asUTC - date.getTime();
  }
  function parseInTz(str, tz) {
    var m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(str || '').trim());
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0);
    var off = tzOffsetMs(new Date(guess), tz);
    var ts = guess - off;
    off = tzOffsetMs(new Date(ts), tz);   // second pass fixes DST-edge cases
    return guess - off;
  }
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  /* v4.37 preview helper: on an UNPUBLISHED theme only (Shopify.theme.role !== 'main') the URL parameter
     ?kk_now=2026-10-09T10:00 (Europe/Berlin) shifts the clock for all promo windows, kept for the tab session,
     so a promo can be checked in the theme preview before it starts. ?kk_now=off clears it. The live theme ignores it. */
  var nowShift = 0;
  try {
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    if (role && role !== 'main') {
      var qn = new URLSearchParams(location.search).get('kk_now');
      if (qn === 'off') sessionStorage.removeItem('kk_now');
      else if (qn) sessionStorage.setItem('kk_now', qn);
      var sn = sessionStorage.getItem('kk_now');
      if (sn) { var at = parseInTz(sn, 'Europe/Berlin'); if (!isNaN(at)) nowShift = at - Date.now(); }
    }
  } catch (e) {}
  var nowMs = function () { return Date.now() + nowShift; };

  class KKCountdown extends HTMLElement {
    connectedCallback() {
      this.tz = this.getAttribute('data-tz') || 'Europe/Berlin';
      var startStr = String(this.getAttribute('data-start') || '').trim();
      this.start = startStr ? parseInTz(startStr, this.tz) : NaN;
      if (!String(this.getAttribute('data-end') || '').trim()) {          // no deadline = always shown (after the start)
        if (isNaN(this.start)) { this._live(true); return; }
        this.end = Infinity;
      } else {
        this.end = parseInTz(this.getAttribute('data-end'), this.tz);
      }
      this.mode = this.getAttribute('data-expired') || 'hide';
      this.$ = { d: this.querySelector('[data-cd-d]'), h: this.querySelector('[data-cd-h]'), m: this.querySelector('[data-cd-m]'), s: this.querySelector('[data-cd-s]') };
      if (isNaN(this.end)) { this._expire(); return; }
      this._tick = this._tick.bind(this);
      this._tick();
      this._timer = setInterval(this._tick, 1000);
    }
    disconnectedCallback() { clearInterval(this._timer); }
    _live(on) {
      var was = this.classList.contains('is-live');
      this.classList.toggle('is-live', on);
      if (was !== on) this.dispatchEvent(new CustomEvent('kk:countdown:live', { bubbles: true }));
      this.querySelectorAll('[data-cd-input]').forEach(function (el) { el.disabled = !on; });
    }
    _expire() {
      clearInterval(this._timer);
      this._live(false);
      this.classList.add('is-expired');
      if (this.mode === 'hide') {
        var wrap = this.closest('[data-cd-wrap]') || this;
        wrap.setAttribute('hidden', '');
        wrap.classList.add('is-expired');
      }
      this.dispatchEvent(new CustomEvent('kk:countdown:expired', { bubbles: true }));
    }
    _tick() {
      if (!isNaN(this.start) && nowMs() < this.start) { this._live(false); return; }   // not started yet
      if (!this.classList.contains('is-live')) this._live(true);
      if (this.end === Infinity) return;
      var left = this.end - nowMs();
      if (left <= 0) {
        if (this.$.d) this.$.d.textContent = '0';
        ['h', 'm', 's'].forEach(function (k) { if (this.$[k]) this.$[k].textContent = '00'; }, this);
        this._expire();
        return;
      }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (this.$.d) this.$.d.textContent = String(d);
      if (this.$.h) this.$.h.textContent = pad(h);
      if (this.$.m) this.$.m.textContent = pad(m);
      if (this.$.s) this.$.s.textContent = pad(s);
    }
  }
  if (!customElements.get('kk-countdown')) customElements.define('kk-countdown', KKCountdown);

  /* v4.37: hide elements inside a promo window (data-hide-start / data-hide-end, Europe/Berlin). */
  function syncHideWindows() {
    var now = nowMs();
    document.querySelectorAll('[data-hide-start],[data-hide-end]').forEach(function (el) {
      var tz = el.getAttribute('data-tz') || 'Europe/Berlin';
      var a = parseInTz(el.getAttribute('data-hide-start'), tz), b = parseInTz(el.getAttribute('data-hide-end'), tz);
      var inside = (isNaN(a) || now >= a) && (isNaN(b) || now < b) && !(isNaN(a) && isNaN(b));
      /* a class, not [hidden]: the set-tiles script resets tile.hidden on every variant refresh */
      if (inside === el.classList.contains('kk-hide-win')) return;
      el.classList.toggle('kk-hide-win', inside);
      if (inside && el.matches('[data-set-tile].is-active')) {
        var grid = el.parentElement, next = grid && grid.querySelector('[data-set-tile]:not([hidden]):not(.kk-hide-win)');
        if (next) next.click();
      }
    });
    /* v4.37: the reverse - elements with data-show-start / data-show-end are shown only inside the window
       (rendered with .kk-hide-win so they stay hidden without JS). */
    document.querySelectorAll('[data-show-start],[data-show-end]').forEach(function (el) {
      var tz = el.getAttribute('data-tz') || 'Europe/Berlin';
      var a = parseInTz(el.getAttribute('data-show-start'), tz), b = parseInTz(el.getAttribute('data-show-end'), tz);
      var inside = (isNaN(a) || now >= a) && (isNaN(b) || now < b) && !(isNaN(a) && isNaN(b));
      if (inside !== el.classList.contains('kk-hide-win')) return;
      el.classList.toggle('kk-hide-win', !inside);
      if (!inside && el.matches('[data-set-tile].is-active')) {
        var grid = el.parentElement, next = grid && grid.querySelector('[data-set-tile]:not([hidden]):not(.kk-hide-win)');
        if (next) next.click();
      }
    });
  }
  document.addEventListener('DOMContentLoaded', syncHideWindows);
  setInterval(syncHideWindows, 30000);
  syncHideWindows();

  /* Sticky announcement bar: publish its live height as --kk-ab-h so the sticky header
     (top: var(--kk-ab-h)) sits right below it; 0 when the bar is gone/hidden. */
  function syncBarHeight() {
    var bar = document.querySelector('.section-announcement');
    var h = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--kk-ab-h', Math.round(h) + 'px');
  }
  ['DOMContentLoaded', 'load', 'resize', 'kk:countdown:expired', 'kk:countdown:live'].forEach(function (ev) {
    (ev === 'resize' ? window : document).addEventListener(ev, syncBarHeight);
  });
  syncBarHeight();
})();
